import { z } from 'zod'

/**
 * The view state this page reads from the URL: which store is open, which of
 * its runs, and which page of runs. All of it, so a link to "OTTO DE, the run
 * that failed this morning" opens exactly that.
 *
 * Every field optional and `.catch(undefined)` — see CLAUDE.md §4.5
 * for why both.
 */
export const inventorySyncSearchSchema = z.object({
  store: z
    .number()
    .int()
    .positive()
    .optional()
    .catch(undefined)
    .describe('The store whose push panel and runs are open, by id.'),
  run: z
    .string()
    .min(1)
    .optional()
    .catch(undefined)
    .describe("The run of that store's open in the run detail, by id."),
  page: z
    .number()
    .int()
    .positive()
    .optional()
    .catch(undefined)
    .describe("The page of the store's runs; 1 by default."),
})

export type InventorySyncSearch = z.infer<typeof inventorySyncSearchSchema>

export const INVENTORY_SYNC_SEARCH_DEFAULTS = { page: 1 } as const

/** Drop any value that equals its default, so the URL carries only what differs. */
export function withoutSearchDefaults(search: InventorySyncSearch): InventorySyncSearch {
  const pruned: InventorySyncSearch = {}
  if (search.store !== undefined) pruned.store = search.store
  if (search.run !== undefined) pruned.run = search.run
  if (search.page !== undefined && search.page !== INVENTORY_SYNC_SEARCH_DEFAULTS.page) {
    pruned.page = search.page
  }
  return pruned
}
